import { createGlobalStyle } from "styled-components";
import backgroundImage from "../image/BACKGROUND_DESKTOP_POWPIX.jpg";
import backgroundImageMobile from "../image/BACKGROUND_MOBILE_POWPIX.jpg";

export const lightTheme = {
  background: "#e4e731ff",
  backgroundSecondary: "#3b0068",
  text: "#ffffff",
  textSecondary: "#cccccc",
  primary: "#7f13d1ff",
  primaryDark: "#3b0068",
  accent: "#da5bff",
};

export const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    min-height: 100vh;

    @media (max-width: 767px) {
      height: max-content;
    }
  }

  body {
    font-family: 'Helvetica Neue', sans-serif;
  
    background-image: url(${backgroundImage});
    background-position: center 0%;
    background-repeat: no-repeat;
    background-size: cover; 
    background-attachment: fixed;
    background-color: #3b0068; 
    
    color: ${({ theme }) => theme.text};
    padding-top: 4rem;

    @media (max-width: 767px) {
      padding: 0;
      background-image: url(${backgroundImageMobile});
      background-size: cover;
      background-position: center center;
      
      /* Centralizando o conteúdo no mobile */
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
    }

     @media (max-width: 767px) {
      padding: 0;
      /* MOBILE — mostra a imagem inteira, sem corte */
      background-image: url(${backgroundImageMobile});
      background-repeat: no-repeat;
      background-size: cover; 
      
      background-position: top center;     
      background-attachment: scroll;       
      background-color: #3b0068;          
      display: block;                       
      min-height: 100vh;
    }
    
    @media (max-width: 480px) {
      background-attachment: scroll;
    }
  }

  * {
    box-sizing: border-box;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  #root {
    min-height: 100vh;
    
    @media (max-width: 767px) {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      padding-top: 14rem;
    }
  }
`;
